import React, { useRef, useEffect, useState, Fragment } from "react";

const AutoCompleteResult = React.memo((props) => {
   const node = useRef();
   const [open, setOpen] = useState(false);
   const [maxResults, setMaxResults] = useState(15);

   useEffect(() => {
      if (props.maxResults) setMaxResults(props.maxResults);
      document.addEventListener("mousedown", handleClick);

      return () => {
         document.removeEventListener("mousedown", handleClick);
      };
   }, [props.maxResults]);

   useEffect(() => {
      if (props.results && props.results.length > 0) {
         setOpen(true);
      } else {
         setOpen(false);
      }
   }, [props.results]);

   const renderItem = (item, key) => {
      if (!props.type) {
         return (
            <li key={key} className="result-item w-100">
               <a
                  href="#"
                  className="w-100"
                  onClick={(e) => {
                     e.preventDefault();
                     props.selectResult(item.city, item.citycode);
                  }}
               >
                  ({item.citycode}) - {item.city}
               </a>
            </li>
         );
      } else if (props.type === "lieu") {
         return (
            <li key={key} className="result-item w-100">
               <a
                  href="#"
                  className="w-100"
                  onClick={(e) => {
                     e.preventDefault();
                     props.selectResult(item.nom);
                  }}
               >
                  {item.nom}
               </a>
            </li>
         );
      } else if (["physique", "indivi", "moral"].includes(props.type) && key < maxResults) {
         return (
            <li key={key} className="result-item w-100">
               <a
                  href="#"
                  className="w-100"
                  onClick={(e) => {
                     e.preventDefault();
                     if (props.selectResult) {
                        if (props.type === "moral") {
                           props.selectResult(item.ddenom, item.nee); // Adjust as needed
                        } else {
                           props.selectResult(item.ddenom);
                        }
                     }
                  }}
               >
                  {item.ddenom} {item.nee}
               </a>
            </li>
         );
      } else if (["cpte_comm"].includes(props.type) && key < maxResults) {
         return (
            <li key={key} className="result-item w-100">
               <a
                  href="#"
                  className="w-100"
                  onClick={(e) => {
                     e.preventDefault();
                     if (props.selectResult) {              
                           props.selectResult(item.codecommunal);
                     }
                  }}
               >
                  {item.codecommunal}
               </a>
            </li>
         );
      }
      return null;
   };

   const handleClick = (e) => {
      if (node.current && !node.current.contains(e.target)) {
         setOpen(false);
      }
   };

   const onHandleMouseLeave = () => {
      setOpen(false);
   };

   return (
      <>
         {open && props.results.length > 0 && (
            <div className="ue-filter-panel" style={{ zIndex: 1000 }} ref={node}>
               <ul className="results" onMouseLeave={onHandleMouseLeave}>
                  {props.results.map((item, key) => renderItem(item, key))}
               </ul>
            </div>
         )}
      </>
   );
});

export default AutoCompleteResult;
